import styled from 'styled-components'
import { colors, getFontStyle } from '@diversioteam/diversio-ds'

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    margin: 1rem;
    background-color: ${colors.primary10};
    border: 1px solid ${colors.primary30};
    border-radius: 0.5rem;
    text-align: center;
`

export const ErrorIcon = styled.div`
    font-size: 2rem;
    margin-bottom: 1rem;
`

export const ErrorMessage = styled.p`
    ${getFontStyle('p02Regular')}
    color: ${colors.primary90};
    line-height: 1.5;
    margin: 0;
    max-width: 400px;
`
